import {
	isFollowUpMessage,
	isStreamAnswerPart,
	isStreamError,
	isStreamResponse,
	type Message,
	type Sources,
} from '@atlassian/conversation-assistant-service-api/types/assistance-service';

import { isUHTraceAnalyzingState, isUHTraceContentSearch, type UHStreamMessage } from './types';

interface UpdatedMessage {
	type:
		| 'CONTENT_SEARCH'
		| 'ANSWER_PART'
		| 'FINAL_RESPONSE'
		| 'ANALYSING_STATE'
		| 'ERROR'
		| 'FOLLOW_UP_QUERIES';
	content?: Message | Sources | string | string[];
}

export const getUHUpdatedMessage = (
	streamMessage: UHStreamMessage,
	currentMessage: Message,
): UpdatedMessage | null => {
	if (isUHTraceContentSearch(streamMessage)) {
		return {
			type: 'CONTENT_SEARCH',
			content: (streamMessage.message as { formulated_query: string })?.formulated_query || '',
		};
	}
	if (isUHTraceAnalyzingState(streamMessage)) {
		return {
			type: 'ANALYSING_STATE',
			content: (streamMessage.message as { sources: Sources })?.sources || '',
		};
	}
	if (isStreamAnswerPart(streamMessage)) {
		return {
			type: 'ANSWER_PART',
			content: {
				...currentMessage,
				content: currentMessage.content.toString() + streamMessage.message.content,
			},
		};
	}
	if (isStreamResponse(streamMessage)) {
		return {
			type: 'FINAL_RESPONSE',
			content: {
				...streamMessage.message.message,
			},
		};
	}
	if (isStreamError(streamMessage)) {
		return {
			type: 'ERROR',
		};
	}
	if (isFollowUpMessage(streamMessage)) {
		return {
			type: 'FOLLOW_UP_QUERIES',
			content: streamMessage.message.follow_ups?.map((f) => f.text) ?? [],
		};
	}
	return null;
};
